import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const EVENTS = {
  ROOT: `${PRIVATE_ROOT}/community/events/`,
  ATTENDING: `${PRIVATE_ROOT}/community/events/attending/`,
  MY_EVENTS: `${PRIVATE_ROOT}/community/events/my-events/`,
}
export const ADD_EVENT = `${PRIVATE_ROOT}/community/events/add`
export const EDIT_EVENT = `${PRIVATE_ROOT}/community/events/:id/edit`
export const VIEW_EVENT = `${PRIVATE_ROOT}/community/events/:id/view`
export const EVENT_PAYMENT = `${PRIVATE_ROOT}/community/events/payment/:id`
export const EVENT_CONFIRMATION = `${PRIVATE_ROOT}/community/events/confirmation/:id/payment/:paymentId`
